import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllJobs = async ({
  companyCode,
  locationCode,
  isTrue = true,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode = "",
}) => {
  let url = `${Api_EndPoints.GetAllJob}?isAllCompanies=${isAllCompanies}&isAll=true&isTrue=${isTrue}&CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;
  if (isAllCompanies && userId) {
    url += `&UserId=${userId}`;
  }
  const { data } = await http_payroll.get(url);
  return data;
};

const getEmpJobs = async ({
  companyCode,
  employeeCode,
  projectCode,
  jobCode,
  fromDate,
  toDate,
  locationCode,
}) => {
  let queryString = `?CompanyCode=${companyCode}&FromDate=${fromDate}&ToDate=${toDate}&LocationCode=${locationCode}`;
  if (employeeCode !== 0) {
    queryString += `&Employeecode=${employeeCode}`;
  }
  if (projectCode !== 0) {
    queryString += `&ProjectCode=${employeeCode}`;
  }
  if (jobCode !== 0) {
    queryString += `&Jobcode=${jobCode}`;
  }

  console.log(queryString);
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetEmployeeJobList}${queryString}`,
  );
  return data;
};

const getJobById = async ({ companyCode, locationCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetJobsDetails}?companyCode=${companyCode}&JobID=${code}&LocationCode=${locationCode}`,
  );
  return data;
};

const insertJob = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.InsertJob, input);
  return data;
};

const updateJob = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.UpdateJob, input);
  return data;
};

const deleteJob = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DeleteJob}?CompanyCode=${companyCode}&JobID=${code}`,
  );
  return data;
};

export const useGetJobsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllJob],
    queryFn: () => getAllJobs(input),
  });
};

export const useGetEmpJobsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmployeeJobList],
    queryFn: () => getEmpJobs(input),
  });
};

export const useGetJobByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetJobsDetails],
    queryFn: () => getJobById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertJobMutation = () => {
  return useMutation({
    mutationFn: insertJob,
  });
};

export const useUpdateJobMutation = () => {
  return useMutation({
    mutationFn: updateJob,
  });
};

export const useDeleteJobMutation = () => {
  return useMutation({
    mutationFn: deleteJob,
  });
};
